export default "__VITE_ASSET__97b503c2__"